var React = require('react');

function LargePlayArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 .119v24l21-12-21-12Z","fill":"#fff"}));
}

LargePlayArrow.defaultProps = {"width":"21","height":"25","fill":"none","style":{"marginLeft":"6px"}};

module.exports = LargePlayArrow;

LargePlayArrow.default = LargePlayArrow;
